import React from 'react';
import { GamesView } from 'js/components/common/GamesView';
import NgpGame from 'js/components/main/Games/Game';

export default props => <GamesView
    Game={NgpGame}
    {...props}
    showControls={true}
    showControlsOnHover={false}
/>;
